export default __webpack_public_path__ + "static/media/background.f526da9a.jpg";